export const Events = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="30" viewBox="0 0 32 30" fill="none">
      <path
        d="M7.98535 27.6601C4.12535 27.6601 0.985352 24.5201 0.985352 20.6601V10.1201C0.985352 6.26012 4.12535 3.12012 7.98535 3.12012H21.3553C25.2153 3.12012 28.3553 6.26012 28.3553 10.1201V19.3901C28.3553 19.9401 27.9053 20.3901 27.3553 20.3901C26.8053 20.3901 26.3553 19.9401 26.3553 19.3901V10.1201C26.3553 7.36012 24.1153 5.12012 21.3553 5.12012H7.98535C5.22535 5.12012 2.98535 7.36012 2.98535 10.1201V20.6601C2.98535 23.4201 5.22535 25.6601 7.98535 25.6601C8.53535 25.6601 8.98535 26.1101 8.98535 26.6601C8.98535 27.2101 8.53535 27.6601 7.98535 27.6601Z"
        fill="#424242"
      />
      <path
        d="M27.3445 27.1201C26.8245 27.1201 26.3845 26.7201 26.3445 26.1901C26.3045 25.6401 26.7245 25.1601 27.2745 25.1201C27.7045 25.0901 28.1245 24.9001 28.4445 24.5801C28.7945 24.2301 28.9945 23.7601 28.9945 23.2601C28.9945 22.3501 28.3445 21.5801 27.4545 21.4101L24.4845 20.8801C23.7245 20.7501 22.9945 20.3701 22.4445 19.8101L20.4245 17.8101C20.0245 17.4201 19.4945 17.2301 18.9445 17.2701L10.7745 18.0401C10.4045 18.0701 10.0745 18.2101 9.78454 18.4401L7.80453 20.0101C7.36453 20.3501 7.09454 20.8901 7.09454 21.4501L7.07452 23.2301C7.06452 24.0001 7.53452 24.7001 8.26452 24.9901C8.77452 25.1901 9.03453 25.7701 8.83453 26.2901C8.63453 26.8101 8.05454 27.0501 7.53454 26.8601C6.04454 26.2701 5.05452 24.8101 5.07452 23.2101L5.09454 21.4301C5.10454 20.2701 5.65454 19.1501 6.56454 18.4401L8.53454 16.8801C9.12454 16.4101 9.83453 16.1201 10.5845 16.0601L18.7545 15.2901C19.9045 15.1801 21.0245 15.5901 21.8345 16.4001L23.8645 18.4001C24.1345 18.6701 24.4845 18.8501 24.8445 18.9201L27.8245 19.4501C29.6745 19.7901 31.0145 21.3901 31.0145 23.2601C31.0145 24.2901 30.6145 25.2701 29.8845 26.0001C29.2245 26.6601 28.3645 27.0601 27.4445 27.1201C27.4245 27.1201 27.3945 27.1201 27.3745 27.1201H27.3445Z"
        fill="#424242"
      />
      <path
        d="M22.9148 27.1299H12.9648C12.4148 27.1299 11.9648 26.6799 11.9648 26.1299C11.9648 25.5799 12.4148 25.1299 12.9648 25.1299H22.9148C23.4648 25.1299 23.9148 25.5799 23.9148 26.1299C23.9148 26.6799 23.4648 27.1299 22.9148 27.1299Z"
        fill="#424242"
      />
      <path
        d="M25.135 29.3599C23.365 29.3599 21.915 27.9199 21.915 26.1399C21.915 24.3599 23.355 22.9199 25.135 22.9199C26.915 22.9199 28.355 24.3599 28.355 26.1399C28.355 27.9199 26.915 29.3599 25.135 29.3599ZM25.135 24.9199C24.465 24.9199 23.915 25.4699 23.915 26.1399C23.915 26.8099 24.465 27.3599 25.135 27.3599C25.805 27.3599 26.355 26.8099 26.355 26.1399C26.355 25.4699 25.805 24.9199 25.135 24.9199Z"
        fill="#424242"
      />
      <path
        d="M10.345 29.3599C8.565 29.3599 7.125 27.9199 7.125 26.1399C7.125 24.3599 8.565 22.9199 10.345 22.9199C12.125 22.9199 13.565 24.3599 13.565 26.1399C13.565 27.9199 12.125 29.3599 10.345 29.3599ZM10.345 24.9199C9.675 24.9199 9.125 25.4699 9.125 26.1399C9.125 26.8099 9.675 27.3599 10.345 27.3599C11.015 27.3599 11.565 26.8099 11.565 26.1399C11.565 25.4699 11.015 24.9199 10.345 24.9199Z"
        fill="#424242"
      />
      <path
        d="M9.22461 7.86014C8.67461 7.86014 8.22461 7.41014 8.22461 6.86014V1.64014C8.22461 1.09014 8.67461 0.640137 9.22461 0.640137C9.77461 0.640137 10.2246 1.09014 10.2246 1.64014V6.86014C10.2246 7.41014 9.77461 7.86014 9.22461 7.86014Z"
        fill="url(#paint0_linear_280_53142)"
      />
      <path
        d="M20.1445 7.86014C19.5945 7.86014 19.1445 7.41014 19.1445 6.86014V1.64014C19.1445 1.09014 19.5945 0.640137 20.1445 0.640137C20.6945 0.640137 21.1445 1.09014 21.1445 1.64014V6.86014C21.1445 7.41014 20.6945 7.86014 20.1445 7.86014Z"
        fill="url(#paint1_linear_280_53142)"
      />
      <path
        d="M26.5948 12.3398H2.38477C1.83477 12.3398 1.38477 11.8898 1.38477 11.3398C1.38477 10.7898 1.83477 10.3398 2.38477 10.3398H26.5948C27.1448 10.3398 27.5948 10.7898 27.5948 11.3398C27.5948 11.8898 27.1448 12.3398 26.5948 12.3398Z"
        fill="#424242"
      />
      <defs>
        <linearGradient
          id="paint0_linear_280_53142"
          x1="8.22461"
          y1="4.24014"
          x2="10.2246"
          y2="4.24014"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F4C074" />
          <stop offset="0.34" stop-color="#E3B16A" />
          <stop offset="1" stop-color="#BE7B2B" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_280_53142"
          x1="19.1445"
          y1="4.24014"
          x2="21.1445"
          y2="4.24014"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#F4C074" />
          <stop offset="0.34" stop-color="#E3B16A" />
          <stop offset="1" stop-color="#BE7B2B" />
        </linearGradient>
      </defs>
    </svg>
  );
};
